import { render, staticRenderFns } from "./oa-wangeditor.vue?vue&type=template&id=7ece5070&scoped=true"
import script from "./oa-wangeditor.vue?vue&type=script&lang=js"
export * from "./oa-wangeditor.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&lang=css&external"
import style1 from "./oa-wangeditor.vue?vue&type=style&index=1&id=7ece5070&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ece5070",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ece5070')) {
      api.createRecord('7ece5070', component.options)
    } else {
      api.reload('7ece5070', component.options)
    }
    module.hot.accept("./oa-wangeditor.vue?vue&type=template&id=7ece5070&scoped=true", function () {
      api.rerender('7ece5070', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-common/oa-wangeditor.vue"
export default component.exports